import type { FC } from 'react';

import { CompletedCheckIcon, ProtoCompletedInfo, ProtoCompletedRow, ProtoRevisitButton } from '../TrainingCard';
import { NamedContentEntryText } from '../../../ContentEntryText/NamedContentEntryText';

type CompletedTrainingCardProps = {
  name: string;
  campaignUrl?: string;
  dueDate: string;
};

export const CompletedTrainingCard: FC<CompletedTrainingCardProps> = ({
  campaignUrl,
  dueDate,
  name,
}: CompletedTrainingCardProps) => {
  const isExpired = new Date(dueDate).getTime() < Date.now();

  return (
    <ProtoCompletedRow>
      <ProtoCompletedInfo>
        <CompletedCheckIcon viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="12" cy="12" r="10" />
          <path d="m9 12 2 2 4-4" />
        </CompletedCheckIcon>
        <span>{name}</span>
      </ProtoCompletedInfo>
      <ProtoRevisitButton
        disabled={!campaignUrl || isExpired}
        onClick={() => {
          if (campaignUrl && !isExpired) {
            window.open(campaignUrl, '_blank', 'noopener,noreferrer');
          }
        }}
      >
        <NamedContentEntryText container="span" refKey="yourTraining" subKey="revisit" />
      </ProtoRevisitButton>
    </ProtoCompletedRow>
  );
};
